<label class="text-primary d-flex align-items-center" for="{{ for() }}">
  <span translate><ng-content></ng-content></span>
  @if(textInfo() || template()) {
  <info-point [textInfo]="textInfo()" [template]="template()" class="ms-1"></info-point>
  } @if(required()) {
  <span class="small text-danger ms-1">*</span>
  }
</label>
